import React from 'react';
import CtaBox from 'components/cta-box/cta-box';
import CtaBoxTitle from 'components/cta-box/cta-box-title';
import CtaBoxMedia from 'components/cta-box/cta-box-media';
import Header3 from 'components/typography/header-3';
import P1 from 'components/typography/p-1';
import { Lexeme } from '@bumble/localization/components';
import A11yVisuallyHidden from 'components/a11y/a11y-visually-hidden';
// import Image from 'next/image';

const CARDS_TITLE_TEXT_GAP_COMPENSATION = 16;
const CARD_IMAGE_HEIGHT = 200;

export type CardType = {
    key?: string;
    imageUrl?: string;
    url?: string;
    title?: string;
    text?: string;
};

const UpdatesCard: React.FC<CardType> = ({ key, imageUrl, url, title, text }) => {
    const content = (
        <CtaBox full={true}>
            {imageUrl ? (
                <CtaBoxMedia noMargin={true}>
                    <div className="updates-card__media">
                        <img
                            className="cta-box__media-img"
                            src={imageUrl}
                            width={280}
                            height={CARD_IMAGE_HEIGHT}
                            alt=""
                        />
                    </div>
                </CtaBoxMedia>
            ) : (
                <div style={{ height: CARD_IMAGE_HEIGHT }} />
            )}

            {title ? (
                <CtaBoxTitle>
                    <span className="updates-card__title">
                        <Header3>
                            <a
                                className="updates-card__url"
                                href={url}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {title}

                                <A11yVisuallyHidden>
                                    <Lexeme path="mw@link.a11y.label.new-window" />
                                </A11yVisuallyHidden>
                            </a>
                        </Header3>
                    </span>
                </CtaBoxTitle>
            ) : (
                ''
            )}
            {text ? (
                <CtaBoxTitle marginTop={CARDS_TITLE_TEXT_GAP_COMPENSATION}>
                    <span className="updates-card__text">
                        <P1>{text}</P1>
                    </span>
                </CtaBoxTitle>
            ) : (
                ''
            )}
        </CtaBox>
    );
    return (
        <li className="updates-card__item" key={key}>
            {content}
        </li>
    );
};

export default UpdatesCard;
